import { render, staticRenderFns } from "./InputNumerico.vue?vue&type=template&id=0a782729&"
import script from "./InputNumerico.vue?vue&type=script&lang=js&"
export * from "./InputNumerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports